import {client} from '@/utils/gql'
import {ProductFragment} from '@/utils/graphqlSdk'
import {NotFoundError} from '@/utils/server/errors'

const getByIdOrNull = async (id: string): Promise<ProductFragment | null> =>
  (await client.productGetById({id})).product_by_pk || null

const getById = async (id: string): Promise<ProductFragment> => {
  const product = await getByIdOrNull(id)

  if (!product) {
    throw new NotFoundError('Product does not exist', {id})
  }

  return product
}

export const productOrm = {
  getById,
  getByIdOrNull,
}
